<template>
  <div class="meituanProductMapping">
    <div class="search_warp">
      <el-form class="search_form" :inline="true" :model="searchForm">
        <el-form-item label="美团商品ID">
          <el-input v-model.trim="searchForm.dealGroupId" placeholder="请输入ID" clearable />
        </el-form-item>
        <el-form-item label="理疗商品货号">
          <el-input v-model.trim="searchForm.artNo" placeholder="请输入货号" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" clearable placeholder="全部状态">
            <el-option label="启用" value="0" />
            <el-option label="停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="['', '0', 0, -1].includes(deptId)" class="action_warp">
      <el-button type="primary" @click="handleUpdateMeituanProducts">更新美团商品</el-button>
      <el-button type="primary" @click="handleAddMapping">新增商品映射</el-button>
    </div>
    <div class="table_warp">
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column prop="dealGroupId" label="美团商品ID" width="140" />
        <el-table-column prop="meituanDealTitle" label="美团商品名称" min-width="220" show-overflow-tooltip />
        <el-table-column prop="artNo" label="理疗商品货号" width="140" />
        <el-table-column prop="physioName" label="理疗商品名称" min-width="220" show-overflow-tooltip/>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" active-value="0" inactive-value="1" :disabled="!['', '0', 0, -1].includes(deptId) || [null, undefined, ''].includes(scope.row.artNo)" @change="statusChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button v-if="['', '0', 0, -1].includes(deptId)" type="primary" size="mini" @click="handleEdit(scope.row.dealGroupId)">编辑</el-button>
            <el-button v-if="['', '0', 0, -1].includes(deptId)" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="handlePageChange"
      />
    </div>
    <el-dialog
      title="编辑商品映射"
      :visible.sync="editDialogMap.visible"
      width="520px"
      :close-on-click-modal="false"
      @close="closeDialog">
      <el-form
        ref="editForm"
        v-loading="editDialogMap.loading"
        :model="editDialogMap.form"
        :rules="editDialogMap.rules"
        label-width="130px">
        <template v-if="editDialogMap.type === 'add'">
          <el-form-item label="美团商品ID：" required prop="dealGroupId">
            <el-input v-model.trim="editDialogMap.form.dealGroupId" placeholder="请输入美团商品ID"></el-input>
          </el-form-item>
          <el-form-item label="美团商品名称：" required prop="meituanDealTitle">
            <el-input v-model.trim="editDialogMap.form.meituanDealTitle" placeholder="请输入美团商品名称"></el-input>
          </el-form-item>
        </template>
        <template v-if="editDialogMap.type === 'edit'">
          <el-form-item label="美团商品ID：" required prop="dealGroupId">
            <span>{{ editDialogMap.form.dealGroupId }}</span>
          </el-form-item>
          <el-form-item label="美团商品名称：" required prop="meituanDealTitle">
            <span>{{ editDialogMap.form.meituanDealTitle }}</span>
          </el-form-item>
        </template>
        <el-form-item label="理疗商品货号：" prop="artNo">
          <el-select
            v-model="editDialogMap.form.artNo"
            placeholder="请输入理疗项目名称/货号"
            class="editDialog_select"
            popper-class="meituan-table-select_popper"
            filterable
            remote
            :remote-method="remotePhysioList"
            @change="onPhysioSelect">
            <div class="table-select_complex-header">
              <div class="table-select_complex-header-item select_complex_artNo">货号</div>
              <div class="table-select_complex-header-item select_complex_name">理疗项目名称</div>
              <div class="table-select_complex-header-item select_complex_Standard">执行模式</div>
              <div class="table-select_complex-header-item select_complex_unit">单位</div>
            </div>
            <div class="table-select_complex-list">
              <el-option v-for="item in editDialogMap.physioProductList" :key="item.artNo" :label="item.artNo" :value="item.artNo">
                <div class="table-select_complex-option">
                  <div class="table-select_complex-option-item select_complex_artNo">{{ item.artNo }}</div>
                  <div class="table-select_complex-option-item select_complex_name">{{ item.drugName }}</div>
                  <div class="table-select_complex-option-item select_complex_Standard">
                    <template v-if="item.executionMode === 10">按次执行</template>
                    <template v-if="item.executionMode === 20">按组执行</template>
                  </div>
                  <div class="table-select_complex-option-item select_complex_unit">{{ item.unit }}</div>
                </div>
              </el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称：" required>
          <span>{{ editDialogMap.form.physioName }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="handleConfirm" :loading="editDialogMap.loading">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/utils/request'

export default {
  name: 'MeituanProductMapping',
  data() {
    return {
      loading: false,
      deptId: this.$session.get('deptId'),
      searchForm: {
        dealGroupId: '',
        artNo: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      editDialogMap: {
        visible: false,
        loading: false,
        type: 'add',
        physioProductList: [],
        rules: {
          dealGroupId: [{ required: true, message: '请输入美团商品ID', trigger: 'blur' }],
          meituanDealTitle: [{ required: true, message: '请输入美团商品名称', trigger: 'blur' }],
          artNo: [{ required: true, message: '请输入货号', trigger: 'blur' }]
        },
        form: {
          dealGroupId: '',
          meituanDealTitle: '',
          artNo: '',
          physioName: ''
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const { code, rows, total } = await req.get('/meituan/queryShopDealPhysioMappingPage',{
          dealGroupId: this.searchForm.dealGroupId,
          artNo: this.searchForm.artNo,
          status: this.searchForm.status,
          pageNum: this.searchForm.pageNum,
          pageSize: this.searchForm.pageSize
        })
        if (code === 200) {
          this.tableData = rows || []
          this.total = total || 0
        }
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        dealGroupId: '',
        artNo: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    async handleUpdateMeituanProducts() {
      this.loading = true
      try {
        const res = await req.post('/meituan/syncMeiTuanProduct',{})
        if (res.code === 200) {
          this.$message.success('更新成功')
          this.getList()
        }
      } finally {
        this.loading = false
      }
    },
    handleAddMapping() {
      this.editDialogMap.type = 'add'
      this.editDialogMap.visible = true
    },
    async handleEdit(dealGroupId) {
      this.editDialogMap.type = 'edit'
      this.editDialogMap.visible = true
      await this.getDetail(dealGroupId)
    },
    async getDetail(dealGroupId) {
      this.editDialogMap.loading = true
      try {
        const { code, data } = await req.get('/meituan/queryShopDealPhysioMapping', { dealGroupId: dealGroupId })
        if (code === 200 && data) {
          this.editDialogMap.form.dealGroupId = data.dealGroupId
          this.editDialogMap.form.meituanDealTitle = data.meituanDealTitle
          this.editDialogMap.form.artNo = data.artNo
          this.editDialogMap.form.physioName = data.physioName
        }
      } finally {
        this.editDialogMap.loading = false
      }
    },
    handleConfirm() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.editDialogMap.loading = true
          try {
            let url = '/meituan/saveShopDealPhysioMapping'
            if (this.editDialogMap.type === 'edit') {
              url = '/meituan/editShopDealPhysioMapping'
            }
            const res = await req.post(url, this.editDialogMap.form)
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.closeDialog()
              this.getList()
            }
          } finally {
            this.editDialogMap.loading = false
          }
          this.closeDialog()
        }
      })
    },
    closeDialog() {
      this.editDialogMap.visible = false
      this.editDialogMap.form.dealGroupId = ''
      this.editDialogMap.form.meituanDealTitle = ''
      this.editDialogMap.form.artNo = ''
      this.editDialogMap.form.physioName = ''

      this.editDialogMap.physioProductList = []
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    async statusChange (row) {
      const res = await req.post('/meituan/editShopDealPhysioMappingStatus', {
        dealGroupId: row.dealGroupId,
        status: row.status
      })
      if (res.code === 200) {
        this.$message.success('更新成功')
        this.getList()
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该美团商品信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await req.get('/meituan/deleteShopDealPhysioMapping', {
          dealGroupId: row.dealGroupId
        })
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getList()
        }
      }).catch(() => {})
    },
    handlePageChange(page) {
      this.searchForm.pageNum = page
      this.getList()
    },
    async remotePhysioList (query) {
      if (query) {
        const res = await req.get('/meituan/queryPhysioForMeiTuan', {
          keyword: query,
          pageNo: 1,
          pageSize: 100
        })
        if (res.code === 200) {
          this.editDialogMap.physioProductList = res.data && res.data.list || []
        }
      } else {
        this.editDialogMap.physioProductList = []
      }
    },
    onPhysioSelect () {
      if (this.editDialogMap.form.artNo) {
        const physio = this.editDialogMap.physioProductList.find(item => item.artNo === this.editDialogMap.form.artNo)
        if (physio) {
          this.editDialogMap.form.physioName = physio.drugName
        }
      } else {
        this.editDialogMap.form.physioName = ''
      }
    }
  }
}
</script>

<style lang="less">
  .meituan-table-select_popper .el-select-dropdown__list {
    padding: 0;
  }
</style>
<style lang="less" scoped>
.meituanProductMapping {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.search_warp {
  padding: 16px 16px 0;
}

.search_form .el-form-item {
  margin-bottom: 0;
}

.search_form .el-form-item /deep/ .el-form-item__label {
  line-height: 32px;
}

.search_form .el-form-item /deep/ .el-form-item__content {
  line-height: 32px;
}

.action_warp {
  padding: 16px 16px 0;
}

.table_warp {
  flex: 1;
  padding: 16px;
  overflow: auto;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

.editDialog_select {
  width: 100%;
}

.table-select_complex-header {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.table-select_complex-header-item {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 12px;
  height: 36px;
  font-size: 14px;
  color: #667182;
  background-color: #F0F1F3;
}

.table-select_complex-list {
  width: 100%;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}

.table-select_complex-list /deep/ .el-select-dropdown__item {
  padding: 0;
  height: 36px;
  line-height: 36px;
}

.table-select_complex-option {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.table-select_complex-option-item {
  box-sizing: border-box;
  padding: 0 12px;
  height: 36px;
  line-height: 36px;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  background-color: #FFFFFF;
}

.table-select_complex-list /deep/ .hover .table-select_complex-option-item {
  color: #1890FF;
  background-color: #E8F4FF;
}

.select_complex_artNo {
  width: 100px;
}

.select_complex_name {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select_complex_Standard {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select_complex_unit {
  width: 80px;
}

</style>
